<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11iUy8n/tc-custom/9781610595216.jpg?1726455549824" alt="This image is the cover for the book Complete Guide to Vegan Food Substitutions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Complete Guide to Vegan Food Substitutions
      </h1>
      <p class="bookDescription body article font2">
        <p>Veganize any recipe with confidence! The Complete Guide to Vegan Food Substitutions is your secret weapon to turning any recipe imaginable into a deliciously “veganized” success—no guesswork or hard labor involved. And no more kitchen failures or recipe flops either. Simply look up whatever non-vegan ingredient you want to sub out, and expert author team Celine Steen and Joni Marie Newman will explain exactly what substitution is best to use and how to make it without compromising taste or flavor, so you’ll create dishes that are not only better than the “real” thing, but healthier, too. With more than 200 recipes and substitutions that show the swaps in action, you’ll find step-by-step instructions for replacing everything from butter and bacon to gelatin and gouda. You’ll also find healthy substitutions for replacing things like gluten, sugar, and fat, so you can fine-tune any recipe to your dietary needs. You and your family and friends will be amazed and delighted with these and more plant-based dishes:     ·Eggs Benedict with Ham   ·Western Bacon Cheeseburgers   ·Indian-Spiced Pumpkin Gratin   ·Cheesy "Chicken" Casserole   ·Fish-y Sticks with Tartar Sauce   ·Walnut Chocolate Brownies   ·Vanilla Latte Ice CreamStunning photography and easy-to-follow charts appear in every chapter, making it a cinch to dip in and out whenever you need a quick reference or recipe. If you’ve always wanted to turn your aunt’s famous mac and cheese into a veganized taste sensation, or your grandma’s buttermilk pie into a rousing, “reinvented” success, The Complete Guide to Vegan Food Substitutions is the solution you’ve been looking for!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Celine Steen, Joni Marie Newman
      </h2>
      
      <p class="authorDescription body article">Celine Steen is the co-author of 500 Vegan Recipes, The Complete Guide to Vegan Food Substitutions, Hearty Vegan Meals, Vegan Sandwiches Save the Day!, Whole Grain Vegan Baking, The Great Vegan Protein Book, and The Great Vegan Grains Book. She is the founder of the award-winning blog Have Cake, Will Travel (havecakewilltravel.com).Joni Marie Newman is the founder of justthefood.com and the author of 10 vegan cookbooks, including 500 Vegan Recipes, The Complete Guide to Vegan Food Substitutions, Hearty Vegan Meals, and Vegan Food Gifts. Joni is well-known in the vegan community and frequently speaks at vegan conferences, cooking demos, and other events. She likes to spread the vegan love on Twitter @JoniMarieNewman.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34af7724